import axios from "axios";
export const getDynamicTableData = (
  id,
  clients,
  clientGroups,
  collaborators,
  collaboratorRole,
  year,
  squads,
  clusters,
  businessUnits,
  sortBy,
  clientTypes,
  clientCRMTypes,
  searchWord,
  budgetStatus,
  clientCRMGroup,
  deletedStatus,
  offshoreStatus,
  facturableStatus,
  pageSize,
  startPage
) => {
  const requestUrl = `/team/dynamic-table`;
  let params = {
    organizationId: id,
    clients: clients.map(({ value }) => value),
    clientTypes: JSON.stringify(clientTypes),
    clientCRMTypes: JSON.stringify(clientCRMTypes),
    clientGroups,
    collaborators: collaborators.map(({ value }) => value),
    collaboratorRole,
    period: year,
    squads: squads.map(({ value }) => value),
    clusters: clusters.map(({ value }) => value),
    businessUnits: businessUnits.map(({ value }) => value),
    sortBy: sortBy,
    pageSize: pageSize,
    startPage: startPage,
    facturableStatus: facturableStatus,
    searchWord,
    // searchWord: searchWord.replace("'", "\\'"),
    budgetStatus,
    withBudgetaryBenchmark: true,
    groupDescriptions: JSON.stringify(clientCRMGroup),
    deletedStatus,
    offshoreStatus
  };

  return axios.get(requestUrl, {
    params
  });
};

export const updateBudgetParts = ({ organization, budget }) => {
  const requestUrl = `/team/budget/parts/update`;
  let formData = new FormData();
  formData.append("organization", organization);
  formData.append("budget", JSON.stringify(budget));

  return axios.post(requestUrl, formData);
};



// WEBPACK FOOTER //
// ./src/api/dynamic-table.js